import { createURLSearchParams } from '../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../common/customAxios';

export interface ICropLiveTradeDataParams {
  searchParam: {
    wholesaleMarketCode: string;
    largeCategoryCode: string;
    middleCategoryCode: string;
    smallCategoryCode: string;
    page: number;
    count: number;
  };
}

export interface ICropLiveTradeData {
  tradeDate: string;
  wholesaleMarketName: string;
  corporationName: string;
  unitQuantity: number;
  unitName: string;
  packageName: string;
  placeOfOriginName: string;
  quantity: number;
  successfulBidPrice: number;
  successfulBidDateTime: string;
}

export const getCropLiveTradeData = ({ searchParam }: ICropLiveTradeDataParams): Promise<ICropLiveTradeData[]> => {
  const URLSearchParams = createURLSearchParams(searchParam ?? {});
  return customAxios.get(`/crops/live-trade-data?${URLSearchParams}`);
};
